import { useState } from "react";
import { TESTIMONIALS } from "../mock";
import { Quote, ArrowLeft, ArrowRight, Star } from "lucide-react";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];

  const prev = () => setI((i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((i + 1) % TESTIMONIALS.length);

  return (
    <section className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-5 reveal">
            <p className="text-xs tracking-[0.25em] uppercase text-neutral-500 mb-4">
              — Kind Words
            </p>
            <h2 className="display text-[40px] md:text-[56px] leading-[1.02]">
              What my clients{" "}
              <span className="relative inline-block">
                <span className="relative z-10">say</span>
                <span className="absolute left-0 right-0 bottom-1 h-3 md:h-4 bg-[#FFE14D] -z-0 rounded-sm" />
              </span>
              .
            </h2>
            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={prev}
                aria-label="previous"
                className="w-12 h-12 rounded-full border-2 border-black flex items-center justify-center hover:bg-black hover:text-white transition-colors"
              >
                <ArrowLeft size={18} />
              </button>
              <button
                onClick={next}
                aria-label="next"
                className="w-12 h-12 rounded-full border-2 border-black flex items-center justify-center hover:bg-black hover:text-white transition-colors"
              >
                <ArrowRight size={18} />
              </button>
              <span className="text-sm text-neutral-500 ml-2">
                {String(i + 1).padStart(2, "0")} /{" "}
                {String(TESTIMONIALS.length).padStart(2, "0")}
              </span>
            </div>
          </div>

          <div className="md:col-span-7 reveal">
            <div className="relative bg-neutral-50 rounded-[28px] p-8 md:p-12 border border-black/5">
              <Quote
                size={40}
                className="absolute top-6 right-6 md:top-8 md:right-8 text-[#FFE14D] fill-[#FFE14D] opacity-70 md:opacity-100"
              />
              <div className="flex items-center gap-1 mb-6">
                {[...Array(5)].map((_, k) => (
                  <Star
                    key={k}
                    size={16}
                    className="text-[#F59E0B] fill-[#F59E0B]"
                  />
                ))}
              </div>
              <p key={t.id} className="display text-xl sm:text-2xl md:text-[30px] leading-[1.3] mb-8 fade-up">
                “{t.quote}”
              </p>
              <div className="flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-14 h-14 rounded-full object-cover border-2 border-white shadow"
                />
                <div>
                  <p className="font-semibold text-[15px]">{t.name}</p>
                  <p className="text-sm text-neutral-500">{t.role}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
